import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { useColorScheme } from '@mui/material/styles';
import { LightModeOutlined, DarkModeOutlined } from '@mui/icons-material';

// Signal dark ⇄ Signal light (DWLF-298). Until the user picks, the mode is 'system' and follows the OS;
// a click stores an explicit choice, which MUI keeps in localStorage ('dwlf-theme').
export default function ThemeModeToggle() {
  const { mode, systemMode, setMode } = useColorScheme();
  if (!mode) return null; // first render, before the stored mode is read

  const current = mode === 'system' ? systemMode : mode;
  const next = current === 'dark' ? 'light' : 'dark';
  const label = `Switch to ${next} mode`;

  return (
    <Tooltip title={label}>
      <IconButton
        onClick={() => setMode(next)}
        aria-label={label}
        sx={{
          color: 'var(--dwlf-ink-70)',
          borderRadius: 0,
          '&:hover': { color: 'var(--dwlf-accent)', backgroundColor: 'var(--dwlf-accent-10)' },
        }}
      >
        {current === 'dark' ? <LightModeOutlined fontSize="small" /> : <DarkModeOutlined fontSize="small" />}
      </IconButton>
    </Tooltip>
  );
}
